import { render, staticRenderFns } from "./HotAndNewBusinessCard.vue?vue&type=template&id=726b041c&scoped=true&"
import script from "./HotAndNewBusinessCard.vue?vue&type=script&lang=js&"
export * from "./HotAndNewBusinessCard.vue?vue&type=script&lang=js&"
import style0 from "./HotAndNewBusinessCard.vue?vue&type=style&index=0&id=726b041c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726b041c",
  null
  
)

export default component.exports